import { render, staticRenderFns } from "./DxpCardCarousel.vue?vue&type=template&id=0720a44b&scoped=true&"
import script from "./DxpCardCarousel.vue?vue&type=script&lang=js&"
export * from "./DxpCardCarousel.vue?vue&type=script&lang=js&"
import style0 from "./DxpCardCarousel.vue?vue&type=style&index=0&id=0720a44b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0720a44b",
  null
  
)

export default component.exports